if (!customElements.get('grid-controls')) {
  class GridControls extends HTMLElement {
    constructor() {
      super();
      this.buttons
    }

    connectedCallback() {
      this.buttons = this.querySelectorAll('button');

      this.buttons.forEach(button => {
        button.addEventListener('click', this.handleClick.bind(this))
      })
    }

    handleClick(e) {
      const container = this.closest('[grid-controls-container]');
      const val = e.target.getAttribute('grid-cols');

      if (!container || !val) {
        return;
      }

      this.buttons.forEach(button => {
        button.classList.remove('is-active');
      });

      e.target.classList.add('is-active');
      container.setAttribute('mobile-grid-cols', val)
    }
  }
  customElements.define('grid-controls', GridControls);
}
